<template>
  <div class="zone-edit">
    <div class="header">
      <h2>大屏演示数据</h2>
      <div>
        <a-button type="primary" @click="handleBack">
          <i class="iconfont icon-fanhuiicon mr5"></i> 返回
        </a-button>
      </div>
    </div>

    <div class="form-container">
      <a-form
          :model="mockFormData"
          layout="vertical"
          class="edit-form"
      >
        <!-- 设备演示数据 -->
        <div class="horizontal-form-row">
          <div class="form-left">
            <h3 class="section-title">设备演示数据</h3>
          </div>
          <div class="form-right">
            <a-switch
                v-model:checked="mockFormData.deviceMockState"
                checked-children="开"
                un-checked-children="关"
            />
          </div>
        </div>

        <a-form-item label="设备演示JSON数据" v-if="mockFormData.deviceMockState">
          <a-textarea
              v-model:value="mockFormData.deviceMockData"
              placeholder="请输入设备演示数据的JSON格式内容"
              :rows="5"
              class="large-textarea"
          />
          <div class="help-text">示例格式：{"total": 10, "data": [{"deviceType":"MEC","count":"151"},{"deviceType":"高清固定摄像机","count":"137"},{"deviceType":"毫米波雷达","count":"102"},{"deviceType":"激光雷达","count":"88"},{"deviceType":"RSU","count":"58"}]}</div>
        </a-form-item>

        <!-- 车辆演示数据 -->
        <div class="horizontal-form-row">
          <div class="form-left">
            <h3 class="section-title">车辆演示数据</h3>
          </div>
          <div class="form-right">
            <a-switch
                v-model:checked="mockFormData.testCarMockState"
                checked-children="开"
                un-checked-children="关"
            />
          </div>
        </div>

        <a-form-item label="测试车辆数据" v-if="mockFormData.testCarMockState">
          <a-textarea
              v-model:value="mockFormData.testCarMockData"
              placeholder="请输入测试车辆总数"
              :rows="3"
              class="large-textarea"
          />
          <div class="help-text">示例格式：{"total": 5}</div>
        </a-form-item>

        <div class="horizontal-form-row">
          <div class="form-right" style="display: flex; justify-content: center;">
            <a-button @click="handleBack" class="mr10">取消</a-button>
            <a-button type="primary" @click="saveDemoData">保存配置</a-button>
          </div>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { message } from 'ant-design-vue';
import { useRoute, useRouter } from 'vue-router';
import { getMockDataByZoneId, updateById} from '@/api/dashboardMock';

const router = useRouter();
const route = useRoute();

const mockFormData = ref({
  zoneId: undefined,
  deviceMockState: true,
  deviceMockData: '',
  testCarMockState: true,
  testCarMockData: ''
});

const getDashboardMockData = async () => {

  const res = await getMockDataByZoneId(route.query.id)
  if (res.code === 200){
    const data = {...res.data};
    if (data.deviceMockData && typeof data.deviceMockData === 'object') {
      data.deviceMockData = JSON.stringify(data.deviceMockData, null, 2);
    }
    if (data.testCarMockData && typeof data.testCarMockData === 'object') {
      data.testCarMockData = JSON.stringify(data.testCarMockData, null, 2);
    }
    mockFormData.value = data;
  }
}

// 保存大屏演示数据
const saveDemoData = async () => {
  try {
    // 准备保存的数据
    const saveData = { ...mockFormData.value };
    saveData.id = route.query.id;
    // 将JSON字符串转换回对象
    if (typeof saveData.deviceMockData === 'string') {
      saveData.deviceMockData = JSON.parse(saveData.deviceMockData);
    }
    if (typeof saveData.testCarMockData === 'string') {
      saveData.testCarMockData = JSON.parse(saveData.testCarMockData);
    }

    await updateById(saveData).then(res =>{
      if (res.code === 200){
        message.success('大屏演示数据保存成功');
        router.push('/zone/index');
      }else {
        message.error('保存失败，请检查JSON格式是否正确');
      }
    })

  } catch (error) {
    console.error('保存大屏演示数据失败:', error);
    message.error('保存失败，请检查JSON格式是否正确');
  }
};

// 返回上一页
const handleBack = () => {
  if (window.history.length > 1) {
    router.back();
  } else {
    router.push('/zone/index');
  }
};

// 页面加载时获取数据
onMounted(async () => {
  await getDashboardMockData();
});

</script>

<style scoped>
/* 主容器样式 */
.zone-edit {
  padding: 20px;
  background-color: #ffffff;
  min-height: calc(100vh - 70px);
}

/* 头部样式 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
  }
}

/* 表单容器样式 */
.form-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 10px 0;
}

/* 编辑表单样式 */
.edit-form {
  width: 100%;
}

/* 水平表单行样式 */
.horizontal-form-row {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;

  .form-left {
    flex: 0 0 150px;
  }

  .form-right {
    flex: 1;
  }
}

/* 区域标题样式 */
.section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #262626;
}

/* 帮助文本样式 */
.help-text {
  margin-top: 8px;
  color: #8c8c8c;
  font-size: 12px;
  word-break: break-all;
}

/* 大文本框样式 */
.large-textarea {
  width: 100%;
  resize: vertical;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .horizontal-form-row {
    flex-direction: column;

    .form-left {
      flex: none;
      width: 100%;
      margin-bottom: 8px;
    }
  }

  .header h2 {
    font-size: 16px;
  }
}
</style>